import { getModel } from '../../model/registry'
import CardView from "../cardView/CardView"
import TabView from "./layouts/TabView"
import CompositeView from "./layouts/CompositeView"
import FilteredView from "./layouts/FilteredView"
import MultiView from "../multiView/MultiView"
import MasterDetailView from "../masterDetailView/MasterDetailView"
import KanbanPage from "../kanbanPage/KanbanPage"
import DisplayView from "../displayView/DisplayView"
import WorkPlannerPage from "../workPlanner/WorkPlannerPage"
import ProcessView from "../processView/ProcessView"

const PageLayout = ({ type, options, dispatch }) => {
    const config = getModel('pageViewData')[type]

    // Page-level settings the card needs: where Back goes, and the work
    // queue the page belongs to (38.04 — Save opens the next record).
    const enrichedOptions = config.backOverride || config.queue
        ? {
            ...options,
            ...(config.backOverride && { backOverride: config.backOverride }),
            ...(config.queue && { queue: config.queue })
        }
        : options

    //console.log('[PageLayout] config: ', config)

    //console.log('re-rendering PageLayout')
    return (
        <>
            {config.type === 'simpleCard' && <CardView type={config.view ?? config.viewType} options={enrichedOptions} dispatch={dispatch}
                />}

            {config.type === 'simpleDisplay' && <DisplayView type={config.view ?? config.viewType} options={enrichedOptions}
                />}

            {config.type === 'tabView' && <TabView type={config.view ?? config.viewType} options={enrichedOptions} dispatch={dispatch}
                 />}

            {config.type === 'compositeView' && <CompositeView type={config.view ?? config.viewType} options={enrichedOptions} />}

            {config.type === 'filteredView' && <FilteredView options={enrichedOptions}
                dispatch={dispatch} config={config} />}

            {config.type === 'multiView' && <MultiView type={config.view ?? config.viewType} options={enrichedOptions}
                dispatch={dispatch} config={config} />}

            {config.type === 'MasterDetailView' && <MasterDetailView type={type} options={options} dispatch={dispatch}
                />}

            {config.type === 'kanbanPage' && <KanbanPage type={config.view ?? config.viewType} options={options} dispatch={dispatch}
                />}

            {config.type === 'plannerPage' && <WorkPlannerPage type={config.view ?? config.viewType} />}

            {config.type === 'processView' && <ProcessView config={config} options={enrichedOptions} dispatch={dispatch} />}

        </>
    )

}

export default PageLayout